import React from 'react';
import {LoginLayout} from '../../Layouts/LoginLayout';
import {useAuth0} from '@auth0/auth0-react';
import {useParameterizedQuery} from 'react-fetching-library';
import {decodeAuth0Token} from '../../Actions/Users/UsersActions';
import {Auth0TokenData, Auth0TokenValidateRequest} from '../../Actions/Users/UsersDomain';
import {useNavigate, useParams} from 'react-router-dom';
import {addUserLogin} from '../../Context/AuthProvider/AuthProviderActions';
import {UserOutlined} from '@ant-design/icons';
import {EmptyState} from '../../Components/EmptyState';
import {useAuthDispatch, useAuthState} from '../../Context/AuthProvider/AuthProvider';
import {useAlertDispatcherState} from '../../Context/AlertProvider/AlertProvider';
import {addAlert} from '../../Context/AlertProvider/AlertProviderActions';
import {Alert} from 'antd';
import {validateCompany} from '../../Actions/Company/CompanyActions';

export const UsersInfoPage:React.FunctionComponent = (_props) => {
    const [auth0TokenData, setAuth0TokenData] = React.useState<Auth0TokenData>();
    const [validCompany, setValidCompany] = React.useState<string>();
    const [isLoadedCompany, setIsLoadedCompany] = React.useState<boolean>(false);
    const [isAuth0InfoLoading, setIsAuth0InfoLoading] = React.useState<boolean>(false);
    const [isApiLoading, setIsApiLoading] = React.useState<boolean>(false);

    const [message, setMessage] = React.useState<string>();
    const [errorMessage, setErrorMessage] = React.useState<string>('');

    const auth0 = useAuth0();
    const decodeAuth0TokenAction =  useParameterizedQuery(decodeAuth0Token);
    const validateCompanyAction = useParameterizedQuery(validateCompany);

    const { companyStr } = useParams();

    const authData = useAuthState();
    const authDispatch = useAuthDispatch();

    const alertDispatch = useAlertDispatcherState();

    const navigate = useNavigate();

    const loading = React.useMemo( () => {
        return decodeAuth0TokenAction.loading || authData.loading || auth0.isLoading || validateCompanyAction.loading;
    }, [auth0.isLoading, authData.loading, decodeAuth0TokenAction.loading, validateCompanyAction.loading] );

    const checkLogin = React.useCallback( ()=>{
        const checkSession = async () => {
            if ( auth0.user !== undefined){
                try {
                    return await auth0.getAccessTokenSilently();
                } catch (error : unknown) {
                    console.error(error);
                }
            }

            return '';
        };

        checkSession().then( r => {
            setMessage('Validando Sesión Global');
            setIsAuth0InfoLoading(true);

            if ( r !== '' && auth0.user !== undefined ){
                const checkIDToken = async () => {
                    try {
                        return await auth0.getIdTokenClaims();
                    } catch (error : unknown) {
                        console.error(error);
                        setErrorMessage('Error al validar la sesión de usuario');
                    }

                    return undefined;
                };

                checkIDToken().then( idToken => {
                    if (idToken){
                        const data :Auth0TokenData = {
                            access_token: r,
                            expires_in: 80000,
                            id_token: idToken.__raw,
                            token_type: 'bearer',
                            scope: ''
                        };

                        setAuth0TokenData( data );
                    }
                } );
            }else{
                setErrorMessage('No existe session activa de usuario');
                setMessage('Proceso Finalizado');
            }
        });
    }, [auth0] );

    React.useEffect(()=>{
        if(validCompany !== undefined && !auth0.isLoading){
            setTimeout( ()=>{
                checkLogin();
            }, 300 );
        }

    }, [auth0.isLoading, checkLogin, validCompany]);

    React.useEffect( ()=>{
        if( validCompany !== undefined && auth0TokenData !== undefined ){
            if(!isApiLoading) {
                setMessage('Validando Token');
                setIsApiLoading(true);

                const tokenDataRequest: Auth0TokenValidateRequest = {
                    company: validCompany,
                    ...auth0TokenData
                };

                decodeAuth0TokenAction.query(tokenDataRequest).then((res) => {
                    setMessage(undefined);

                    if (res.error) {
                        setErrorMessage('Existio un error al comunicarse con el servidor');
                        return;
                    }

                    const payload = res.payload;
                    if (!(payload === undefined || payload === null)) {
                        if (payload.error['has-error'] && payload.error['error'] !== undefined) {
                            setErrorMessage(payload.error['error']);
                            return;
                        }

                        sessionStorage.setItem('auth0-login', 'ok');
                        addUserLogin(payload, authDispatch).then( _r => {
                            if(payload.response.user){
                                navigate(`/edit-user/${ payload.response.user.id }`);
                            }
                        } );
                    }
                });

            }
        }

    }, [companyStr, auth0TokenData, decodeAuth0TokenAction, authDispatch, isAuth0InfoLoading, navigate, validCompany] );

    React.useEffect( ()=>{
        if( errorMessage !== '' ){
            addAlert('Error', errorMessage, 'error', alertDispatch);
            // setErrorMessage( "" )
        }
    }, [alertDispatch, errorMessage] );


    React.useEffect( ()=>{
        if (!isLoadedCompany && companyStr !== undefined){
            setIsLoadedCompany(true);
            setMessage('Verificando Empresa asociada...');

            validateCompanyAction.query( companyStr ).then( r => {
                if ( r.payload  ){
                    if ( r.payload.error['has-error'] ){
                        setErrorMessage('La empresa asociada no esta correctamente configurada, contácte a su administrador');
                    }else{
                        setValidCompany(companyStr);
                    }
                }
            } );
        }
    }, [companyStr, isLoadedCompany, validateCompanyAction] );

    return (
        <LoginLayout loginTitle="Control de Usuarios"
                     loginSubtitle="Estamos validando la informacion proporcionada, porfavor espere un momento..."
        >
            { errorMessage && <Alert type="error" message={errorMessage} />}
            <EmptyState
                loading={ loading }
                icon={<UserOutlined />}
                message={(message !== null) ? message : 'Obteniendo información del Servidor'}
            />
        </LoginLayout>
    );
};
